
import { ElForm, ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import UploadFormItem from '@/components/form/common/UploadFormItem.vue'
import {
  MaterialTypeModel,
  MaterialTypePageSearchModel,
  MaterialTypeSearchModel,
  MaterialTypeAddModel,
  MaterialTypeUpdateModel,
  IdsModel
} from '@/model/product/MaterialTypeModel'
import {
  pageSearchMaterialType,
  // addMaterialType,
  updateMaterialType,
  removeMaterialType,
  batchRemoveMaterialType
} from '@/apis/product/materialType'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { selectOptionFormat } from '@/utils/options'
import { /* Language, */ MaterialType } from '@/constant/options'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import networkConfig from '@/config/default/net.config'
import { Route } from '@/constant/route'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer,
    UploadFormItem
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const updateUpload = ref()
    const createUpload = ref()
    const materialTypeOption = selectOptionFormat(MaterialType.materialTypeOptions, t, MaterialType.i18nKey)
    const searchStruct = [
      { prop: 'name', label: t('materialType.name'), placeholder: t('materialType.nameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'baseType', label: t('materialType.baseType'), placeholder: t('materialType.baseTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption }
    ]

    const createStruct = [
      { prop: 'name', label: t('materialType.name'), placeholder: t('materialType.nameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'baseType', label: t('materialType.baseType'), placeholder: t('materialType.baseTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption },
      { prop: 'aUsable', label: t('materialType.aUsable'), placeholder: t('materialType.aUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'bUsable', label: t('materialType.bUsable'), placeholder: t('materialType.bUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'cUsable', label: t('materialType.cUsable'), placeholder: t('materialType.cUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'dUsable', label: t('materialType.dUsable'), placeholder: t('materialType.dUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'eUsable', label: t('materialType.eUsable'), placeholder: t('materialType.eUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'fUsable', label: t('materialType.fUsable'), placeholder: t('materialType.fUsableP'), component: 'el-checkbox', type: 'text', model: null }
    ]

    const updateStruct = [
      { prop: 'name', label: t('materialType.name'), placeholder: t('materialType.nameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'baseType', label: t('materialType.baseType'), placeholder: t('materialType.baseTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption },
      { prop: 'aUsable', label: t('materialType.aUsable'), placeholder: t('materialType.aUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'bUsable', label: t('materialType.bUsable'), placeholder: t('materialType.bUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'cUsable', label: t('materialType.cUsable'), placeholder: t('materialType.cUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'dUsable', label: t('materialType.dUsable'), placeholder: t('materialType.dUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'eUsable', label: t('materialType.eUsable'), placeholder: t('materialType.eUsableP'), component: 'el-checkbox', type: 'text', model: null },
      { prop: 'fUsable', label: t('materialType.fUsable'), placeholder: t('materialType.fUsableP'), component: 'el-checkbox', type: 'text', model: null }
    ]

    const materialTypeRole = {
      name: [{ required: true, message: t('materialType.name').concat(t('common.isRequired')), trigger: 'blur' }],
      baseType: [{ required: true, message: t('materialType.baseType').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const materialCreateTypeRole = {
      name: [{ required: true, message: t('materialType.name').concat(t('common.isRequired')), trigger: 'blur' }],
      baseType: [{ required: true, message: t('materialType.baseType').concat(t('common.isRequired')), trigger: 'blur' }],
      labelSizeImage: [{ validator: () => createUpload.value ? !createUpload.value.validateUpload() : false, message: t('materialType.labelSizeImage').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'name', label: t('materialType.name'), sortable: 'custom' },
      { prop: 'baseType', label: t('materialType.baseType'), formatter: (row: MaterialTypeModel) => { return materialTypeOption.find(mt => mt.value === row.baseType)?.label }, sortable: 'custom' },
      { prop: 'labelSizeImage', label: t('materialType.labelSizeImage'), sortable: 'custom', img: 'labelSizeImage' },
      { prop: 'ausable', label: t('materialType.aUsable'), formatter: (row: MaterialTypeModel) => { return row.ausable ? t('common.active') : t('common.notActive') }, sortable: 'custom' },
      { prop: 'busable', label: t('materialType.bUsable'), formatter: (row: MaterialTypeModel) => { return row.busable ? t('common.active') : t('common.notActive') }, sortable: 'custom' },
      { prop: 'cusable', label: t('materialType.cUsable'), formatter: (row: MaterialTypeModel) => { return row.cusable ? t('common.active') : t('common.notActive') }, sortable: 'custom' },
      { prop: 'dusable', label: t('materialType.dUsable'), formatter: (row: MaterialTypeModel) => { return row.dusable ? t('common.active') : t('common.notActive') }, sortable: 'custom' },
      { prop: 'eusable', label: t('materialType.eUsable'), formatter: (row: MaterialTypeModel) => { return row.eusable ? t('common.active') : t('common.notActive') }, sortable: 'custom' },
      { prop: 'fusable', label: t('materialType.fUsable'), formatter: (row: MaterialTypeModel) => { return row.fusable ? t('common.active') : t('common.notActive') }, sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: MaterialTypeModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: MaterialTypeModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as MaterialTypeSearchModel,
      tableData: Array<MaterialTypeModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'materialType.edit',
        create: 'materialType.create',
        updateImage: 'materialType.edit'
      },
      dialogFormVisible: false,
      materialTypeRole: materialTypeRole,
      materialCreateTypeRole: materialCreateTypeRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as MaterialTypeAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as MaterialTypeUpdateModel,
      updateImageModel: { id: null, labelSizeImage: null } as any,
      editRow: {} as MaterialTypeModel,
      loadingUpload: null as any,
      updateImageRow: {} as MaterialTypeModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop === 'ausable' ? 'aUsable' : column.prop === 'busable' ? 'bUsable' : column.prop === 'cusable' ? 'cUsable' : column.prop === 'dusable' ? 'dUsable' : column.prop === 'eusable' ? 'eUsable' : column.prop === 'fusable' ? 'fUsable' : column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: MaterialTypePageSearchModel = {
          name: dataMap.searchFormModel.name,
          baseType: dataMap.searchFormModel.baseType,
          aUsable: dataMap.searchFormModel.aUsable,
          bUsable: dataMap.searchFormModel.bUsable,
          cUsable: dataMap.searchFormModel.cUsable,
          dUsable: dataMap.searchFormModel.dUsable,
          eUsable: dataMap.searchFormModel.eUsable,
          fUsable: dataMap.searchFormModel.fUsable,
          labelSizeImage: dataMap.searchFormModel.labelSizeImage,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchMaterialType(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        if (createUpload.value.validateUpload()) {
          return
        }
        dataMap.loadingUpload = ElLoading.service({
          lock: true,
          text: t('common.uploading'),
          background: 'rgba(0, 0, 0, 0.7)'
        })
        await createUpload.value.submitUpload()
      },
      async updateImageSubmit() {
        if (updateUpload.value.validateUpload()) {
          return
        }
        dataMap.loadingUpload = ElLoading.service({
          lock: true,
          text: t('common.uploading'),
          background: 'rgba(0, 0, 0, 0.7)'
        })
        await updateUpload.value.submitUpload()
      }, /*
      async createSubmit() {
        const createData: MaterialTypeAddModel = {
          name: dataMap.createModel.name,
          baseType: dataMap.createModel.baseType,
          aUsable: dataMap.createModel.aUsable,
          bUsable: dataMap.createModel.bUsable,
          cUsable: dataMap.createModel.cUsable,
          dUsable: dataMap.createModel.dUsable,
          eUsable: dataMap.createModel.eUsable,
          fUsable: dataMap.createModel.fUsable,
          labelSizeImage: dataMap.createModel.labelSizeImage
        }
        const result = await addMaterialType(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      }, */
      async updateNameSubmit() {
        const updateData: MaterialTypeUpdateModel = {
          id: dataMap.updateModel.id,
          name: dataMap.updateModel.name,
          baseType: dataMap.updateModel.baseType,
          aUsable: dataMap.updateModel.aUsable,
          bUsable: dataMap.updateModel.bUsable,
          cUsable: dataMap.updateModel.cUsable,
          dUsable: dataMap.updateModel.dUsable,
          eUsable: dataMap.updateModel.eUsable,
          fUsable: dataMap.updateModel.fUsable
        }
        const result = await updateMaterialType(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeMaterialType(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveMaterialType(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.name = dataMap.editRow.name
        dataMap.updateModel.baseType = dataMap.editRow.baseType
        dataMap.updateModel.aUsable = dataMap.editRow.ausable
        dataMap.updateModel.bUsable = dataMap.editRow.busable
        dataMap.updateModel.cUsable = dataMap.editRow.cusable
        dataMap.updateModel.dUsable = dataMap.editRow.dusable
        dataMap.updateModel.eUsable = dataMap.editRow.eusable
        dataMap.updateModel.fUsable = dataMap.editRow.fusable
      },
      createReset() {
        console.log('create reset')
        if (createUpload.value) {
          createUpload.value.onReset()
        }
      },
      updateImageReset() {
        console.log('update image reset')
        dataMap.updateImageModel.id = dataMap.updateImageRow.id
        if (updateUpload.value) {
          updateUpload.value.onReset()
        }
      }
    })
    const handleCreate = () => {
      dataMap.createReset()
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: MaterialTypeModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.name = row.name
        dataMap.updateModel.baseType = row.baseType
        dataMap.updateModel.aUsable = row.ausable
        dataMap.updateModel.bUsable = row.busable
        dataMap.updateModel.cUsable = row.cusable
        dataMap.updateModel.dUsable = row.dusable
        dataMap.updateModel.eUsable = row.eusable
        dataMap.updateModel.fUsable = row.fusable
        dataMap.dialogFormVisible = true
      }
    }
    const handleEditImg = (row?: MaterialTypeModel) => {
      if (row) {
        dataMap.updateImageRow = row
        dataMap.dialogStatus = 'updateImage'
        dataMap.updateImageModel.id = row.id
        dataMap.updateImageReset()
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleCreateUpload = (result: any) => {
      console.log(result)
      if (dataMap.loadingUpload) {
        dataMap.loadingUpload.close()
      }
      if (result?.code === 0) {
        ElMessage({
          message: t('common.createSuccess'),
          type: 'success',
          duration: 2000
        })
        dataMap.dialogFormVisible = false
        dataMap.getList()
      } else {
        ElMessage({
          message: result?.message,
          type: 'error',
          duration: 2000
        })
      }
    }
    const handleUpdateUpload = (result: any) => {
      console.log(result)
      if (dataMap.loadingUpload) {
        dataMap.loadingUpload.close()
      }
      if (result?.code === 0) {
        ElMessage({
          message: t('common.updateSuccess'),
          type: 'success',
          duration: 2000
        })
        dataMap.dialogFormVisible = false
        dataMap.getList()
      } else {
        ElMessage({
          message: result?.message,
          type: 'error',
          duration: 2000
        })
      }
    }
    const getCreateUploadUri = () => {
      return networkConfig.host + Route.product + '/materialType/add'
    }
    const getUpdateUploadUri = () => {
      return networkConfig.host + Route.product + '/materialType/update/labelSizeImage'
    }
    const getUploadHeader = () => {
      return {
        Authorization: 'Bearer ' + useStore().state.user.token
      }
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      handleEditImg,
      searchFormRef,
      getCreateUploadUri,
      getUpdateUploadUri,
      getUploadHeader,
      handleCreateUpload,
      handleUpdateUpload,
      createUpload,
      updateUpload,
      ...toRefs(dataMap)
    }
  }
})
